import React, { useState, useRef } from "react";
import "../../style/display/PDFViewer.css";

const PDFViewer = ({ fileUrl, width, height }) => {
  const [scale, setScale] = useState(1);
  const [controlsVisible, setControlsVisible] = useState(false); // Track visibility of controls
  const iframeRef = useRef(null);

  const transformDriveUrl = (url) => {
    if (url.includes("drive.google.com")) {
      return url
        .replace("/view", "/preview")
        .replace("/edit", "/preview")
        + "?rm=minimal&embedded=true";
    }
    return url;
  };

  const handleZoomIn = () => {
    setScale(prev => Math.min(prev + 0.1, 2));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(prev - 0.1, 0.5));
  };

  const handlePrint = () => {
    if (fileUrl) {
      const printFrame = document.createElement("iframe");
      printFrame.style.display = "none";
      document.body.appendChild(printFrame);

      const printUrl = fileUrl
        .replace("/preview", "/view")
        .replace("/edit", "/view")
        + "?rm=minimal";

      printFrame.src = printUrl;
      printFrame.onload = () => {
        try {
          printFrame.contentWindow?.focus();
          printFrame.contentWindow?.print();
        } catch (error) {
          console.error("Printing failed:", error);
          window.open(printUrl, "_blank");
        }
        document.body.removeChild(printFrame);
      };
    }
  };

  const handleDownload = () => {
    if (fileUrl) {
      const downloadUrl = fileUrl.replace("/preview", "/download");
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.target = "_blank";
      link.download = "document.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const toggleControlsVisibility = () => {
    setControlsVisible(prev => !prev);
  };

  return (
    <div
      className="pdf-viewer-container"
      style={{
        width: width || "100%",
        height: height || "100%",
      }}
    >
      {/* Button to show/hide controls */}
      <button className="toggle-controls-btn" onClick={toggleControlsVisibility}>
        {controlsVisible ? 'Hide Controls' : 'Show Controls'}
      </button>

      {/* Control Buttons */}
      <div
        className={`pdf-controls ${controlsVisible ? 'visible' : ''}`}
      >
        <button onClick={handleZoomIn} title="Zoom In (Ctrl + '+')">Zoom In</button>
        <button onClick={handleZoomOut} title="Zoom Out (Ctrl + '-')">Zoom Out</button>
        <button onClick={handlePrint} title="Print this document">Print</button>
        <button onClick={handleDownload} title="Download PDF">Download</button>
        <span className="zoom-display">{Math.round(scale * 100)}%</span>
      </div>

      {/* PDF content */}
      {fileUrl ? (
        <div
          className="pdf-iframe-wrapper"
          style={{
            transform: `scale(${scale})`,
            transformOrigin: "center",
            transition: "transform 0.2s ease-in-out",
            width: "100%",
            height: "100%",
          }}
        >
          <iframe
            ref={iframeRef}
            src={transformDriveUrl(fileUrl)}
            title="PDF Viewer"
            className="pdf-frame"
          />
        </div>
      ) : (
        <div className="no-pdf-fallback">
          <p className="no-pdf-message">Select a PDF to view</p>
        </div>
      )}
    </div>
  );
};

export default PDFViewer;
